module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-900.1fce17a0.woff";